import {Editor, Path, Transforms} from 'slate';

function removeProcessStep (editor, location) {
  const isFirstStep = location[location.length - 1] === 0;

  Transforms.removeNodes(
    editor,
    {
      at: location,
    }
  );

  const targetPath = isFirstStep
    ? [...location.slice(0, -1), 0, 0]
    : [...Path.previous(location), 0];

  const endPoint = Editor.end(editor, targetPath);
  Transforms.setSelection(editor, {
    anchor: endPoint,
    focus: endPoint,
  });
}

export default removeProcessStep;
